var __jsx = React.createElement;
import classNames from "classnames";
import { every, get } from "lodash";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import React from "react";
import { getFileExtension } from "../utils";
import { formatDate } from "../../../utils";
import { isNonDicomFile, truncateMiddle } from "../../../utils";
import TextInput from "../../FormComponents/TextInput";
import Tooltip from "../../common/Tooltip";
import AwesomeIcon from "../../AwesomeIcon";
import { faXmark, faCheck, faPenToSquare, faCopy, faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
function DesktopFilesList(props) {
  var isSelectAll = props.isSelectAll,
    onSelectAll = props.onSelectAll,
    hasCurrentPatient = props.hasCurrentPatient,
    unSelect = props.unSelect,
    formattedSelectedFiles = props.formattedSelectedFiles,
    editRowId = props.editRowId,
    onChangeRowData = props.onChangeRowData,
    setEditRowId = props.setEditRowId,
    error = props.error,
    invalidFileError = props.invalidFileError,
    onEditData = props.onEditData,
    resetDetails = props.resetDetails,
    setPatientDetail = props.setPatientDetail;
  var selectedFilesKeys = Object.keys(formattedSelectedFiles);
  var onSelectAllFiles = function onSelectAllFiles(e) {
    e.preventDefault();
    trackEvent(MIXPANEL_EVENTS.DICOM_SELECT_ALL_FILES);
    onSelectAll();
  };
  return /*#__PURE__*/React.createElement("table", {
    className: "hidden sm:table min-w-full text-left"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-md font-semibold text-gray-800 dark:text-gray-500"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 bg-gray-200 dark:bg-gray-800 font-medium border-b border-gray-600 text-center align-middle"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "cursor-pointer checked:!bg-teal-400",
    checked: isSelectAll,
    onChange: onSelectAllFiles
  })), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 px-3 py-3.5 bg-gray-200 dark:bg-gray-800 text-left font-medium table-cell border-b border-gray-600"
  }, t("patient_name_id")), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 py-3.5 px-3 bg-gray-200 dark:bg-gray-800 text-left font-medium border-b border-gray-600"
  }, t("age_label")), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 py-3.5 px-3 bg-gray-200 dark:bg-gray-800 text-left font-medium border-b border-gray-600"
  }, t("sex_key")), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 px-3 py-3.5 bg-gray-200 dark:bg-gray-800 text-left font-medium table-cell border-b border-gray-600"
  }, t("study_details")), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 px-3 py-3.5 bg-gray-200 dark:bg-gray-800 text-left font-medium table-cell border-b border-gray-600"
  }, t("series_instance")), /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 px-3 py-3.5 bg-gray-200 dark:bg-gray-800 text-left font-medium table-cell border-b border-gray-600"
  }), !hasCurrentPatient && /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "sticky top-0 z-10 px-3 py-3.5 bg-gray-200 dark:bg-gray-800 text-left font-medium border-b border-gray-600"
  }))), /*#__PURE__*/React.createElement("tbody", {
    className: "text-gray-900 dark:text-gray-200"
  }, selectedFilesKeys.map(function (fileKey, index) {
    var fileObject = formattedSelectedFiles[fileKey];
    var trClassName = classNames({
      "opacity-50": fileObject[0].isValidated && !fileObject[0].isSelected,
      "border-b border-gray-600": index !== selectedFilesKeys.length - 1
    });
    var patientId = get(fileObject, [0, "metaData", "PatientID"], "");
    var patientName = get(fileObject, [0, "metaData", "PatientName"], "");
    var patientGender = get(fileObject, [0, "metaData", "PatientGender"], "");
    var patientAge = get(fileObject, [0, "metaData", "PatientAge"], "");
    var modality = get(fileObject, [0, "metaData", "Modality"], "");
    var studyDate = get(fileObject, [0, "metaData", "StudyDate"], "");
    var seriesInstanceUID = get(fileObject, [0, "metaData", "SeriesInstanceUID"], "");
    var fileType = getFileExtension(get(fileObject, [0, "fileName"], ""));
    var _isNonDicomFile = isNonDicomFile(fileType);
    var isEditTrue = seriesInstanceUID && editRowId === seriesInstanceUID;
    var isSelected = every(fileObject, ["isSelected", true]);
    var isValidated = every(fileObject, ["isValidated", true]);
    return /*#__PURE__*/React.createElement("tr", {
      className: classNames(trClassName, "align-top", {
        "border-2 !rounded-lg !border-teal-500 align-middle": isEditTrue
      }),
      key: fileKey
    }, /*#__PURE__*/React.createElement("td", {
      className: "text-center py-6"
    }, !isEditTrue && /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: classNames("rounded accent-gray-300 checked:!bg-teal-400 cursor-pointer", {
        "opacity-50 !cursor-not-allowed": !isValidated
      }),
      disabled: !isValidated,
      checked: isSelected,
      onChange: function onChange(e) {
        trackEvent(MIXPANEL_EVENTS.DICOM_FILE_SELECTED);
        unSelect(e, fileObject);
      }
    })), /*#__PURE__*/React.createElement("td", {
      className: "py-6"
    }, isEditTrue ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
      type: "text",
      name: "patientName",
      placeholder: t("patient_name"),
      defaultValue: patientName,
      onChange: function onChange(val) {
        return onChangeRowData(val, "patientName");
      },
      error: error["patientName"],
      max: 64,
      wrapperClassName: "w-auto group !py-0",
      isClinicalField: true,
      className: "!bg-transparent border-none",
      inputClassName: "!text-left"
    }), /*#__PURE__*/React.createElement(TextInput, {
      type: "text",
      name: "patientId",
      placeholder: t("patient_id_label"),
      defaultValue: patientId,
      max: 64,
      onChange: function onChange(val) {
        return onChangeRowData(val, "patientId");
      },
      wrapperClassName: "w-auto group !py-0",
      className: "!bg-transparent border-none",
      inputClassName: "!text-left",
      isClinicalField: true,
      error: error["patientId"]
    })) : /*#__PURE__*/React.createElement("div", {
      className: "whitespace-nowrap flex flex-col px-3",
      title: "".concat(patientId, " | ").concat(patientName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-base",
      title: patientName
    }, truncateMiddle(patientName, 20)), /*#__PURE__*/React.createElement("div", {
      title: patientId,
      className: "is-uppercase mt-2 text-md text-gray-700 dark:text-gray-500"
    }, "ID: ", truncateMiddle(patientId, 20)))), /*#__PURE__*/React.createElement("td", {
      className: "py-6"
    }, isEditTrue ? /*#__PURE__*/React.createElement(TextInput, {
      type: "text",
      name: "patientAge",
      placeholder: t("age_label"),
      defaultValue: patientAge,
      onChange: function onChange(val) {
        return onChangeRowData(val, "patientAge");
      },
      error: error["patientAge"],
      wrapperClassName: "w-fit group !py-0",
      className: "!bg-transparent !w-20 border-none",
      inputClassName: "!text-left",
      isClinicalField: true,
      max: 4
    }) : /*#__PURE__*/React.createElement("div", {
      className: "whitespace-nowrap px-3 font-medium"
    }, /*#__PURE__*/React.createElement("p", null, patientAge))), /*#__PURE__*/React.createElement("td", {
      className: "py-6"
    }, isEditTrue ? /*#__PURE__*/React.createElement(TextInput, {
      type: "text",
      name: "patientGender",
      placeholder: t("sex_key"),
      defaultValue: patientGender,
      onChange: function onChange(val) {
        return onChangeRowData(val, "patientGender");
      },
      error: error["patientGender"],
      wrapperClassName: "w-fit group !py-0",
      className: "!bg-transparent !w-20 border-none",
      inputClassName: "!text-left",
      isClinicalField: true,
      max: 6
    }) : /*#__PURE__*/React.createElement("div", {
      className: "whitespace-nowrap px-3 font-medium"
    }, /*#__PURE__*/React.createElement("p", null, patientGender ? patientGender : "N/A"))), /*#__PURE__*/React.createElement("td", {
      className: "whitespace-nowrap px-3 py-6 font-medium"
    }, /*#__PURE__*/React.createElement("p", null, formatDate(studyDate))), /*#__PURE__*/React.createElement("td", {
      className: "whitespace-nowrap px-3 py-6 font-medium"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex space-x-2 items-center"
    }, /*#__PURE__*/React.createElement("p", null, "".concat(modality, " .(").concat(fileType, ")")), /*#__PURE__*/React.createElement(Tooltip, {
      className: "cursor-pointer [&_.tooltip-trigger]:my-0 [&_.tooltip-content]:text-sm [&_.tooltip-content]:rounded-6 [&_.tooltip-content]:p-3 [&_.tooltip-content]:px-4 [&_.tooltip-content]:text-gray-100",
      tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Series UID: ", seriesInstanceUID)),
      position: "right",
      verticalPosition: "bottom"
    }, !_isNonDicomFile && /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleInfo,
      size: "sm"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex space-x-2 items-center text-gray-700 dark:text-gray-500"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCopy,
      size: "xs"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-md"
    }, fileObject === null || fileObject === void 0 ? void 0 : fileObject.length))), !isEditTrue && /*#__PURE__*/React.createElement("td", {
      className: "whitespace-nowrap px-3 py-6 table-cell text-dark-800 dark:text-white"
    }, invalidFileError(fileObject)), !hasCurrentPatient && /*#__PURE__*/React.createElement("td", {
      colSpan: isEditTrue ? 2 : 1,
      className: "py-6"
    }, isEditTrue ? /*#__PURE__*/React.createElement("div", {
      className: "flex space-x-3 justify-center items-center"
    }, /*#__PURE__*/React.createElement("button", {
      disabled: Object.values(error).filter(function (err) {
        return err.length > 0;
      }).length > 0,
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.DICOM_PATIENT_METADATA_SAVED);
        onEditData();
      },
      className: "rounded-md p-3 bg-teal-500 hover:bg-teal-600 disabled:opacity-70 disabled:bg-teal-500"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCheck,
      className: "text-gray-200 w-6 h-6"
    })), /*#__PURE__*/React.createElement("button", {
      className: "rounded-md p-3 bg-gray-600 hover:bg-gray-700",
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.DICOM_FILE_EDIT_CANCELLED);
        resetDetails();
      }
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faXmark,
      className: "text-gray-200 w-6 h-6"
    }))) : /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.DICOM_FILE_EDIT_OPENED);
        setEditRowId(seriesInstanceUID);
        setPatientDetail({
          patientName: patientName,
          patientId: patientId,
          patientAge: patientAge,
          patientGender: patientGender
        });
      },
      disabled: !isSelected,
      className: classNames("text-gray-600 cursor-not-allowed", {
        "hover:text-teal-600 dark:hover:text-gray-100 cursor-pointer": isSelected
      })
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faPenToSquare,
      className: "w-6"
    }))));
  })));
}
export default DesktopFilesList;